export enum BadgeLevel {
  Default = 'default', // gray
  Brand = 'brand', // brand
  Information = 'information', // orange
  Success = 'success', // green
  Warning = 'warning', // yellow
  Error = 'error', // red
  Dark = 'dark', // dark gray
  Slot = 'slot', // semi-transparent black for slot badges
}

export enum BadgeShape {
  Pill = 'pill',
  Box = 'box',
}

export enum BadgeSize {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
